module.exports = __webpack_public_path__ + "img/dealer-customer-login.3a957d09.png";